import { useState, useEffect } from 'react';
import { useAuth } from './useAuth';
import { getRoleFromUser, hasAdminPrivileges } from '../types/roles';

interface AdminState {
  isAdmin: boolean;
  loading: boolean;
}

function isAdminFromUser(user: { user_metadata?: Record<string, unknown>; app_metadata?: Record<string, unknown> } | null): boolean {
  if (!user) return false;
  return hasAdminPrivileges(getRoleFromUser(user));
}

export function useAdmin() {
  const { user } = useAuth();
  const [adminState, setAdminState] = useState<AdminState>({
    isAdmin: false,
    loading: true,
  });

  useEffect(() => {
    if (!user) {
      setAdminState({ isAdmin: false, loading: false });
      return;
    }

    setAdminState({ isAdmin: isAdminFromUser(user), loading: false });
  }, [user]);

  return adminState;
}
